import React from "react";
import PTSachNrPageTab from "../Tabs/PTSachNrPage";

const PTSachNrPage = ({ user }) => {
	return <PTSachNrPageTab user={user} />;
};

export default PTSachNrPage;
